import React from 'react';
import {
  HeadTitle,
  Spacer,
  Explain,
  ExplainItem,
  Button,
  CheckboxItem,
} from 'oui';
import { SideBox, FloatingBox, ListBox } from '../etc/LBox/LBox';
import AGREEMENT from '../../application/staticData/info/AGREEMENT';
import { useTerm } from '../../application/bloc/useTerm';
import TermFullSheet from '../feedback/TermFullSheet/TermFullSheet';
import { ReuseBottomsheet } from '../feedback/ReuseBottomsheet/ReuseBottomsheet';
import { useRecoilState } from 'recoil';
import * as Atom from '../../application/recoil';
import StackingSnackbar from '../component/StackingSnackbar/StackingSnackbar';

export const Term = () => {
  const {
    termCheck,
    termFullsheet,
    terms,
    currentPromotionTerms,
    sendBeaconClkBtnAgree,
    sendBeaconClkBtnInputBegin,
    sendBeaconClkBtnInputResume,
    navigateMtgStep,
    setReuseInfo,
    onClickPromotionEvent,
    savePromotionEntry,
  } = useTerm();

  const handleClickCta = async (e: any) => {
    sendBeaconClkBtnAgree(e.target.innerHTML);
    await terms.processAgreeTerm();
    await savePromotionEntry();
  };

  const [, setMortgageInfo] = useRecoilState(Atom.mortgageInfo);

  const handleClickNextBtn = (e: any) => {
    const txt = e.target.innerHTML;
    if (txt === '이어서 입력하기') {
      void setReuseInfo();
      sendBeaconClkBtnInputResume(txt);
    } else if (txt === '처음부터 입력하기') {
      setMortgageInfo(Atom.createDefaultMortgageInfo());
      sendBeaconClkBtnInputBegin(txt);
      navigateMtgStep();
    }
  };

  return (
    <>
      <StackingSnackbar bottom={80} />
      <HeadTitle textTitle={'대출 심사 조회에 필요한\n 약관을 확인해주세요'} />

      <Spacer size={'xs'} />
      <ListBox padding="0 20px" gap={24}>
        {AGREEMENT.map((item) => (
          <ExplainItem
            key={item.title}
            title={item.title}
            subTitle={item.subTitle}
            avatar={{ source: item.source, alt: item.alt }}
          />
        ))}
      </ListBox>
      <Spacer size={'lg'} />

      <SideBox>
        {termCheck.checkList.map((item, idx) => {
          const subTextItem =
            !item.required && currentPromotionTerms // 임의로 선택 약관(required === false) 하위에 이벤트 약관 포함
              ? item.subTextItem.concat(
                  currentPromotionTerms.map(
                    ({ termsFileUrl, title, promotionTermsSeq }: any) => ({
                      title,
                      path: termsFileUrl,
                      termsCd: promotionTermsSeq,
                    }),
                  ),
                )
              : item.subTextItem;

          return (
            <CheckboxItem
              key={idx}
              text={item.text}
              isExpand={item.isExpand}
              checked={item.checked}
              subTextItem={subTextItem}
              onClickCheckBox={() => termCheck.toggleCheckBox(idx)}
              onClickExpand={(e: any) => termCheck.expandItem(e, idx)}
              onClickSubText={(detail: any) =>
                termFullsheet.open(detail.title, detail.path, detail.termsCd)
              }
            />
          );
        })}
        {/* {currentPromotionTerms &&
          currentPromotionTerms.map((item: any, idx: number) => (
            <CheckboxItem
              key={`c_${idx}`}
              text={item.title}
              isExpand={false}
              checked={item.checked}
              onClickCheckBox={() => onClickPromotionEvent(item)}
              onClickExpand={(e: any) =>
                termFullsheet.open(
                  '',
                  item.termsFileUrl,
                  item.promotionTermsSeq,
                )
              }
            />
          ))} */}
      </SideBox>

      <Spacer size="xl" />
      <Spacer size="lg" />

      <FloatingBox>
        <Button
          configuration={'contained'}
          flexible={true}
          onClick={(e: any) => handleClickCta(e)}
          children={'동의하기'}
          state={termCheck.isActive ? 'enabled' : 'disabled'}
          isDisabled={!termCheck.isActive}
        />
      </FloatingBox>

      <TermFullSheet
        isOpen={termFullsheet.isOpen}
        title={termFullsheet.title}
        path={termFullsheet.path}
        onClickClose={termFullsheet.close}
      />

      <ReuseBottomsheet
        isOpen={terms.showReuse}
        onClose={() => terms.setShowReuse(false)}
        onClickButton={(e) => handleClickNextBtn(e)}
        onClickSubButton={(e) => handleClickNextBtn(e)}
      />
    </>
  );
};
